import {palette} from '@/styles';
import {FOOTTRAFFIC_TOP_PERCENTAGE} from '../constants';

export const getFootTrafficTileColor = (v: number) => {
  const colors = ['#ff0000', '#ff0000', palette.teal100, palette.teal100];
  const opacity = [0.5, 0.3, 0.5, 0.3];
  const percent = Math.round(v);
  let idx = -1;

  FOOTTRAFFIC_TOP_PERCENTAGE.some((i, index) => {
    const isTrue = percent <= i;

    if (isTrue) {
      idx = index;
    }

    return isTrue;
  });

  return {
    fillColor: colors[idx] ?? 'transparent',
    fillOpacity: opacity[idx] ?? 0,
  };
};

export const getMobileFootTrafficTileColor = (v: number) => {
  const colors = ['#A50000B3', '#E3000099', '#FF2E0080', '#FF7A0066'];
  const percent = Math.round(v);
  let idx = -1;

  FOOTTRAFFIC_TOP_PERCENTAGE.some((i, index) => {
    const isTrue = percent <= i;

    if (isTrue) {
      idx = index;
    }

    return isTrue;
  });

  return {
    fillColor: colors[idx] ?? 'transparent',
    fillOpacity: 1,
  };
};
